import ImMenu from "@/views/agent_im/components/menu/index";
export default [
    {
        path: "im",
        priority: 100,
        permit: "im",
        menu: { title: ImMenu },
        component: () => import("@/views/agent_im/index/index")
    }
];
